export default {"src":"/_next/static/media/tab_chat.3409977e.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};